import { createContext } from "react";
import { AppGlobalData } from "../types/AppGlobalData";

export const AppContext = createContext({
  appData: {} as AppGlobalData,
  setGlobalData: (appData: AppGlobalData) => {},
});
